import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Observer } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@src/core/services';
import { EnvService } from '@src/app/modules/env';

import { AttachmentItem, AttachmentItems } from '../types';
import { MAX_MESSAGE_LENGTH } from '../../constants';

@Component({
  selector: 'chat-attachment-dialog',
  templateUrl: './attachment-dialog.component.html',
  styleUrls: ['./attachment-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentDialogComponent {
  private readonly env = inject(EnvService);
  private readonly alertService = inject(AlertService);
  private readonly translateService = inject(TranslateService);

  @Input() observer?: Observer<void>;
  @Input() messageText: string = '';
  @Input() attachmentsPreview?: AttachmentItem[];
  @Output() attachmentConfirmed = new EventEmitter<AttachmentItems>();

  readonly maxMessageLength = MAX_MESSAGE_LENGTH;

  get isInputAreaInvalid() {
    return Boolean(this.messageText && this.messageText.length > MAX_MESSAGE_LENGTH);
  }

  get isMobile() {
    return this.env.isMobilePlatform;
  }

  onClickConfirmAttachment(): void {
    if (!this.attachmentsPreview) return;

    let attachments: AttachmentItems = { attachments: this.attachmentsPreview };
    if (this.messageText) {
      if (this.messageText.length > MAX_MESSAGE_LENGTH) {
        this.alertService.error(
          this.translateService.instant('components.internalMessenger.alerts.errors.maxMessageLength'),
        );

        return;
      }

      attachments = { ...attachments, caption: this.messageText };
    }
    this.attachmentConfirmed.emit(attachments);

    this.attachmentsPreview = undefined;
    this.messageText = '';
    this.observer?.complete();
  }
}
